module.exports = __webpack_public_path__ + "fonts/fa-solid-900.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.woff
// module id = 54
// module chunks = 0